// Dev URL
// const discoveryEndpoint = "https://corpextdev.b2clogin.com/corpextdev.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_OIDC_SIGNIN";

// const clientId = "d8262a6b-5315-48b8-9c05-100e3889b582";

// const clientSecret = "Syy8Q~oXk9M.bLcEo.Lcz7j1ZTiEcdyoOs0xGck.";

// Production URL
const discoveryEndpoint = "https://corpsso.b2clogin.com/corpsso.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_OIDC_SIGNIN";

const clientId = "59d86eb4-a9d9-4503-bd8a-566b0f42a70d";

const clientSecret = "UBY8Q~Gulrc5I_r8MQdye9Cw3-FyHZCv4-B3.a4-";

const scope = "openid offline_access";
const redirectUri = "https://ecotrip.thermoking.com";
 
export async function getOpenIDConfig() {
  try {
    const response = await fetch(discoveryEndpoint);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching OpenID configuration:', error);
    return null;
  }
}

export async function redirectToLogin() {
  const config = await getOpenIDConfig();
 
  if (!config || !config.authorization_endpoint) {
    console.error("Authorization endpoint not found in OpenID configuration.");
    return;
  }
 
  const authUrl = `${config.authorization_endpoint}&client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
  
  // console.log("Redirecting to:", authUrl);
  window.location.href = authUrl;
}
 
export async function exchangeCodeForToken(code) {
  const config = await getOpenIDConfig();
  // console.log('config endpoint: ',config.token_endpoint )
  const tokenResponse = await fetch(config.token_endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: new URLSearchParams({
      client_id: clientId,
      client_secret: clientSecret,
      grant_type: "authorization_code",
      redirect_uri: redirectUri,
      code,
    }),
  });
 
  return tokenResponse.json();
}
 
export async function handleAuthCallback() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  if (!code) {
    console.error('Authorization code not found');
    return redirectToLogin();
  }
 
  const tokenData = await exchangeCodeForToken(code);
  if (tokenData.id_token) {
    const idTokenClaims = JSON.parse(atob(tokenData.id_token.split(".")[1]));
    const firstName = idTokenClaims.FirstName || idTokenClaims.firstname;
    if (firstName) {
      localStorage.setItem("ecotrip_user", JSON.stringify({idTokenClaims}));
      console.log('Welcome, ', firstName);
      return idTokenClaims;
    } else {
      console.warn('FirstName claim is missing.');
      redirectToLogin();
    }
  } else {
    console.error('ID Token not present in token response');
    redirectToLogin();
  }
}

  export function logout() {
    localStorage.clear();
    getOpenIDConfig().then(config => {
      if (config && config.end_session_endpoint) {
        const logoutUrl = `${config.end_session_endpoint}&post_logout_redirect_uri=${encodeURIComponent(redirectUri)}`;
        // console.log("Logging out, redirecting to:", logoutUrl);
        window.location.href = logoutUrl;
      } else {
        console.error("End session endpoint not found in OpenID configuration.");
      }
    });
  }